export default "__VITE_ASSET__2ce24d74__"